export default __webpack_public_path__ + "static/media/coffeecup.5dd56a12.svg";